import {Component, Input, OnInit, Output, EventEmitter, Type} from '@angular/core';
import {FloatLabelType, MatFormFieldAppearance} from '@angular/material/form-field';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';

@Component({
  selector: 'app-tdo-dropdown',
  templateUrl: './tdo-dropdown.component.html',
  styleUrls: ['./tdo-dropdown.component.css'] 
})
export class TdoDropdownComponent implements OnInit {
  @Input() placeholder: string;
  @Input() tdolabel: string;
  @Input() dataSource: any[];
  @Input() dataSourceDisplayKey: string;
  @Input() value: any; 
  @Input() suffix: string = '';
  @Input() width: number;
  @Input() height: number;
  @Input() isObjectValue: boolean;
  @Input() floatLabel: FloatLabelType = 'auto';
  @Input() appearance: MatFormFieldAppearance = null;
  @Input() disabled: boolean = false;
  @Input() cypressControlIdentifier: string = 'ctrlTdoDropdownComponent';

  @Output() selectionChange = new EventEmitter<any>();
  @Output() valueChange = new EventEmitter<any>();

  style = '';

  constructor() { }

  ngOnInit(): void {
    //
    if (this.width === undefined) {
      this.style = 'width: 100%; margin-top: 3px;';
    } else {
      this.style = `width: ${this.width}px; margin-top: 3px;`;
    }

    /*if (this.height !== undefined) {
      this.style += `height: ${this.height}px;`;
    }*/
  }

  onChange(event) {
    this.selectionChange.emit(event);
    this.valueChange.emit(this.value);
  }
}
